  (function() {
       var headerSection = document.querySelector('[data-ds-header2]');
       var sectionId = headerSection ? headerSection.closest('.shopify-section').id.replace('shopify-section-', '') : '';

    function headerBottom() {
      var group = document.getElementById('shopify-section-header');
      return group ? Math.max(0, group.getBoundingClientRect().bottom) : 0;
    }

    function init() {
      var header = document.querySelector('[data-ds-header2]');
      if (!header) return;

      var menuBtn = header.querySelector('[data-ds-header2-menu]');
      var searchBtn = header.querySelector('[data-ds-header2-search]');

      if (menuBtn) {
        menuBtn.addEventListener('click', function() {
          var menu = document.getElementById('main-menu');
          if (menu && typeof menu.toggle === 'function') menu.toggle();
        });
      }

      if (searchBtn) {
        searchBtn.addEventListener('click', function() {
          var modal = document.getElementById('search-modal');
          var input = document.getElementById('header-search-input');
          if (!modal || typeof modal.toggle !== 'function') return;
          modal.style.top = headerBottom() + 'px';
          modal.toggle();
          if (!modal.classList.contains('hidden') && input) input.focus();
        });
      }

      // Pro Rewards link goes into the mobile drawer rendered by mega-menu-2
      var smileSlot = document.querySelector('[data-mobile-smile-slot]');
      var smileTemplate = document.getElementById('smile-mobile-menu-template-' + sectionId);
      if (smileSlot && smileTemplate && smileSlot.childElementCount === 0) {
        smileSlot.appendChild(smileTemplate.content.cloneNode(true));
      }
    }

    document.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-smile-open]');
      if (!trigger) return;
      event.preventDefault();
      if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') window.SmileUI.openPanel();
    });

    function wireSearchSuggestions(input, suggestions) {
      if (!input || !suggestions) return;
      var blurTimeout;
      var isFocused = false;

      function sync() {
        suggestions.style.display = !input.value.trim() && isFocused ? '' : 'none';
      }

      input.addEventListener('input', sync);
      input.addEventListener('focus', function() {
        isFocused = true;
        clearTimeout(blurTimeout);
        sync();
      });
      input.addEventListener('blur', function() {
        blurTimeout = setTimeout(function() {
          isFocused = false;
          sync();
        }, 120);
      });
      sync();
    }

    // Same cart count sync as sections/header.liquid (other scripts call window.syncCartCountUI)
    function syncCartCountUI(itemCount) {
      var count = Number(itemCount || 0);
      var titleCount = document.querySelector('[data-mini-cart-title-count]');
      var cartBubble = document.querySelector('#cart-icon-bubble .bubble');
      var cartCountNumber = document.querySelector('#cart-icon-bubble [data-cart-count-number]');
      var cartCountA11y = document.querySelector('#cart-icon-bubble [data-cart-count-a11y]');

      if (titleCount) {
        titleCount.textContent = '(' + count + ')';
        titleCount.classList.toggle('hidden', count <= 0);
      }
      if (cartCountNumber) cartCountNumber.textContent = count > 0 && count < 100 ? String(count) : '';
      if (cartBubble) cartBubble.classList.toggle('hidden', count <= 0);
      if (cartCountA11y) {
        var currentText = cartCountA11y.textContent || '';
        var nextText = currentText.replace(/\d+/, String(count));
        cartCountA11y.textContent = nextText === currentText ? String(count) : nextText;
      }
    }

    window.syncCartCountUI = syncCartCountUI;

    function refreshCartCount() {
      return fetch(window.routes.cart_url + '.js')
        .then(function(response) { return response.json(); })
        .then(function(cartState) { syncCartCountUI(cartState.item_count); })
        .catch(function() {});
    }

    function queueCartCountRefresh() {
      setTimeout(refreshCartCount, 180);
      setTimeout(refreshCartCount, 600);
    }

    document.addEventListener('click', function(event) {
      if (event.target.closest('[data-remove-action]') || event.target.closest('mini-cart quantity-input .quantity__button')) {
        queueCartCountRefresh();
      }
    });

    document.addEventListener('change', function(event) {
      if (event.target.closest('mini-cart quantity-input .quantity__input')) queueCartCountRefresh();
    });

    function start() {
      init();
      wireSearchSuggestions(document.getElementById('header-search-input'), document.querySelector('[data-search-suggestions-header]'));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail && event.detail.sectionId === sectionId) init();
    });

    // Hide on scroll down, show on scroll up. Stays put while a dropdown, drawer or search is open or focused.
    if (!window.dsHeader2ScrollReady) {
      window.dsHeader2ScrollReady = true;
      var lastY = window.scrollY;
      var ticking = false;

      function headerLocked(group) {
        return (
          group.querySelector(':focus-visible') ||
          group.querySelector('.ds-mm2-nav__item.is-open') ||
          group.querySelector('modal-view:not(.hidden)') ||
          group.querySelector('mini-cart:not(.hidden)')
        );
      }

      function onScroll() {
        ticking = false;
        var group = document.getElementById('shopify-section-header');
        if (!group) return;
        var y = window.scrollY;
        var delta = y - lastY;
        if (y <= group.offsetHeight || delta < -6 || headerLocked(group)) {
          group.classList.remove('is-scroll-hidden');
        } else if (delta > 6) {
          group.classList.add('is-scroll-hidden');
        }
        if (Math.abs(delta) > 6) lastY = y;
      }

      window.addEventListener('scroll', function() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(onScroll);
      }, { passive: true });

      // Keyboard users tabbing into the header always get it back. Focus inside the cart drawer or
      // another modal doesn't count: they live inside the header too, and closing one shouldn't bring it back.
      document.addEventListener('focusin', function(event) {
        var group = document.getElementById('shopify-section-header');
        if (!group || !group.contains(event.target)) return;
        if (event.target.closest('mini-cart, modal-view, .modal')) return;
        group.classList.remove('is-scroll-hidden');
      });
    }
  })();